import { Injectable } from '@angular/core';
import { OrderCommandService } from '../data-service/order-command.service';
import { OrderDataService } from '../data-service/order-data.service';
import { LabType } from '../enums/lab-type.enum';
import { CurrentOrder } from '../models/current-order.model';
import { TransactionalData } from '../models/order-creation/transactional-data';
import { LabsiteCheckService } from '../labsite-check/labsite-check.service';

@Injectable({
    providedIn: 'root'
})
export class CreateOrderService {

    constructor(
        private orderCommandService: OrderCommandService,
        private orderDataService: OrderDataService,
        private labsiteCheckService: LabsiteCheckService) {
    }

    async createNewOrder(currentOrder: CurrentOrder, eleCode?: string, transactionalData?: TransactionalData) {
        const lab = await this.orderDataService.getLabType(currentOrder.quotation.receivingLabCode).toPromise();
        const newOrderDetails = await this.orderCommandService.addDraftOrder(currentOrder).toPromise();
        currentOrder.OrderCode = newOrderDetails.orderId;
        currentOrder.OrderReference = newOrderDetails.orderReference;
        const orderReference = await this.orderCommandService.addAllOrderDetails(currentOrder, eleCode,
            transactionalData?.eleCode, await this.labsiteCheckService.isElimsOrTransitionedToElims(currentOrder.quotation.receivingLabCode, lab.type, currentOrder.account.code));
        if (orderReference) {            
            transactionalData.OrderReference = orderReference;
            currentOrder.OrderReference = orderReference;
            const orderData = await this.orderDataService.getOrder(currentOrder.OrderCode).toPromise();
            currentOrder.CreatedOn = orderData.order.orderDetails.orderPlacedOn;
            currentOrder.Status = orderData.order.orderDetails.status;
        } else {
            currentOrder.OrderReference = orderReference;
        }
    }
}
